import { render, staticRenderFns } from "./SharedShortlistsFooter.vue?vue&type=template&id=2256b689&"
import script from "./SharedShortlistsFooter.vue?vue&type=script&lang=js&"
export * from "./SharedShortlistsFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports